// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulppxbi{gap:var(--ds-space-200,1pc)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
